import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import api from '@src/api';

export const state = {
  fitnessTypeModel: null,
  allFitnessTypes: [],
  allFitnessTypesTrueSource: [],
  fitnessTypeDetails: {},
  selectedFitnessType: null,
};

export const getters = {
  hasUnsavedChanges: (state) => {
    return state.hasUnsavedChanges;
  },
};

export const mutations = {
  setAllFitnessTypes(state, value) {
    state.allFitnessTypes = value;
  },
  setAllFitnessTypesTrueSource(state, value) {
    state.allFitnessTypesTrueSource = value;
  },
  setHasChanges(state, value) {
    state.hasUnsavedChanges = value;
  },
  setFitnessTypeDetails(state, value) {
    const clone = cloneDeep(state.fitnessTypeDetails);
    clone[value._id] = value;
    state.fitnessTypeDetails = clone;
  },
  setFitnessTypeModel(state, value) {
    state.fitnessTypeModel = value;
  },
  setSelectedFitnessType(state, value) {
    state.selectedFitnessType = value;
  },
  setCreateFitnessType(state, value) {
    state.allFitnessTypesTrueSource.unshift(value);
    state.allFitnessTypes = state.allFitnessTypesTrueSource;
  },
  setUpdateFitnessTypeItem(state, value) {
    const i = state.allFitnessTypes.findIndex((item) => item._id === value._id);
    const fitnessTypesClone = cloneDeep(state.allFitnessTypes);
    fitnessTypesClone[i] = value;
    state.allFitnessTypes = fitnessTypesClone;

    const j = state.allFitnessTypesTrueSource.findIndex(
      (item) => item._id === value._id
    );
    const fitnessTypesCloneTrueSource = cloneDeep(state.allFitnessTypesTrueSource);
    fitnessTypesCloneTrueSource[j] = value;
    state.allFitnessTypesTrueSource = fitnessTypesCloneTrueSource;
  },
  setDeleteFitnessTypeItem(state, value) {
    const i = state.allFitnessTypesTrueSource.findIndex((item) => item._id === value._id);
    state.allFitnessTypes.splice(i, 1);
    state.allFitnessTypes = state.allFitnessTypesTrueSource;
  },
  setUpdateFitnessTypeTitle(state, value) {
    const fitnessTypeClone = cloneDeep(state.selectedFitnessType);
    fitnessTypeClone.label = value;
    state.selectedFitnessType = fitnessTypeClone;
  },
  setUpdateFitnessTypeDescription(state, value) {
    const fitnessTypeClone = cloneDeep(state.selectedFitnessType);
    fitnessTypeClone.description = value;
    state.selectedFitnessType = fitnessTypeClone;
  },
};

export const actions = {
  getAllFitnessTypes(ctx, { orgId }) {
    if (orgId !== undefined) {
      const url = api.URL_GET_ALL_FITNESS_TYPES.replace(':orgID', orgId)
      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllFitnessTypes', res.data.fitnessTypes);
          ctx.commit('setAllFitnessTypesTrueSource', res.data.fitnessTypes);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid param (orgId) : (${orgId})`
      );
    }
  },
  getFitnessType(ctx, { fitnessTypeId, orgId }) {
    if (
      fitnessTypeId !== undefined &&
      orgId !== undefined
    ) {
      if (!ctx.state.fitnessTypeDetails[fitnessTypeId]) {
        const url = api.URL_GET_FITNESS_TYPE.replace(':fitnessTypeID', fitnessTypeId)
          .replace(':orgID', orgId);

        return axios
          .get(url)
          .then((res) => {
            ctx.commit('setFitnessTypeDetails', res.data.fitnessType);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        return ctx.state.fitnessTypeDetails[fitnessTypeId];
      }
    } else {
      console.error(
        `invalid params (fitnessTypeId, orgId) : (${fitnessTypeId}, ${orgId})`
      );
    }
  },
  createFitnessType(ctx, { fitnessTypeObj }) {
    if (isPayloadValid(fitnessTypeObj)) {
      const url = api.URL_CREATE_FITNESS_TYPE.replace(':orgID', fitnessTypeObj.org_id)

      if (fitnessTypeObj.label !== undefined) {
        const requestPayload = { fitnessType: fitnessTypeObj };

        return axios
          .post(url, requestPayload)
          .then((res) => {
            if (res.data.error) {
              console.error('Error: ', res.data.error);
            } else {
              ctx.commit('setCreateFitnessType', res.data.fitnessType);
              return res.data;
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'fitnessTypeObj must contain the following properties "label"',
          fitnessTypeObj
        );
      }
    } else {
      logError(fitnessTypeObj);
    }
  },
  updateFitnessType(ctx, {fitnessTypeObj }) {
    if (isPayloadValid(fitnessTypeObj)) {
      const url = api.URL_UPDATE_FITNESS_TYPE.replace(':fitnessTypeID', fitnessTypeObj._id)
      .replace(':orgID', fitnessTypeObj.org_id);

      // Minimum data check for obj
      if (fitnessTypeObj.label !== undefined) {
        const requestPayload = { fitnessType: fitnessTypeObj };
        return axios
          .put(url, requestPayload)
          .then((res) => {
            ctx.commit('setUpdateFitnessTypeItem', fitnessTypeObj);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'fitnessTypeObj must contain the following properties to be a valid replacement [org_id, label]',
          fitnessTypeObj
        );
      }
    } else {
      logError(fitnessTypeObj);
    }
  },
  deleteFitnessType(ctx, { fitnessTypeObj }) {
    if (isPayloadValid(fitnessTypeObj)) {
      const url = api.URL_DELETE_FITNESS_TYPE.replace(':fitnessTypeID', fitnessTypeObj._id)
      .replace(':orgID', fitnessTypeObj.org_id);

      return axios
        .delete(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      logError(fitnessTypeObj);
    }
  },
  setHasChanges(ctx, { changesValue }) {
    ctx.commit('setHasChanges', changesValue);
  },
};

// Private Helpers

function isPayloadValid(obj) {
  // Minimum data check for payload
  return (
    obj !== undefined &&
    obj.org_id !== undefined &&
    obj.label !== undefined &&
    typeof obj.label === 'string'
  );
}

function logError(fitnessTypeObj) {
  console.error(
    `Invalid Params: (fitnessTypeObj, trainer_id, org_id) : (${fitnessTypeObj}, ${fitnessTypeObj.org_id})`
  );
}
